import { IDriverOrderStatus, IGetImageData, IGetImageParams, IOrderInfo, IRegisterAccountVerifyStatus } from './types.d';
import { instanceDic, instanceDrisk, instanceDcs } from '@/api/http';
import axios from '@/api/request';
import { IResponseData } from '../../types';
import { UrlUtil } from '@xl/js-utils';
import {
  ICityListItem,
  IFaceAccessCheckResponse,
  IFaceCheckParams,
  IFaceCheckResponse,
  IFetchSubmitJoinParams,
  IGetUploadConfigData,
  IIdentityInfoSaveParams,
  ISubmitDriverInfoParams,
  IUploadIdCardParams,
  IGetEduTaskAndUrlData,
} from './types';
import { AgreementEnum } from '@/enums';

const { token } = UrlUtil.queryParse(window.location.href);

// IP 定位
export function getIpPosition() {
  return axios.get(
    'https://map-api.xiaolachuxing.com/xl-lbs-map-svc/ip/location?key=85b3-d912bf02d1d9&type=ipv4',
  );
}

// 发送验证码
export function fetchRegisterSmsCode(params = {}) {
  return instanceDic.post<IResponseData<any>>('/', {
    name: 'send.register.sms.code',
    data: params,
  }, {
    custom: {
      isReqEncrypt: true,
    },
  });
}

// 我要加入(注册)h5登录
export function fetchJoin(params = {}) {
  return instanceDic.post<IResponseData<any>>('/', {
    name: 'driver.register',
    data: params,
  });
}

// 获取司机信息
export async function fetchJoinInfo(data: { driver_id: string }) {
  return instanceDic.post<any>('/', {
    name: 'get.new.status',
    encode_driver_id: data.driver_id,
    data,
  }, {
    custom: {
      isReqEncrypt: true,
      isResEncrypt: true,
    },
  });
}

// 司机统一注册步骤
export function fetchSubmitJoinData(data: IFetchSubmitJoinParams) {
  const params = data;
  if (typeof data.photo_item === 'string') {
    params.photo_item = JSON.parse(data.photo_item);
  }
  return instanceDic.post<IResponseData<any>>(
    '/',
    {
      name: 'input.driver.info',
      encode_driver_id: data.driver_id,
      city_id: data.city_id,
      data: params,
    },
    {
      showError: false,
    },
  );
}

// 注册OCR识别接口
export function fetchOCRinfo(data = {}) {
  return instanceDrisk.post<IResponseData<any>>('/', {
    name: 'get.ocr.info',
    data: {
      ...data,
      scene: 1,
    },
  });
}

// 人脸识别 token
export function fetchTokenForFace(params = {}) {
  return axios.get<IResponseData<any>>('?_m=register&_a=get_token_by_app', {
    params,
  });
}

// 查询人脸次数
export function fetchTokenUseNumber(params = {}) {
  return axios.get<IResponseData<any>>('?_m=register&_a=getFaceUseNum', {
    params,
  });
}

// 修改司机图片信息
export function fetchUpdateDriverInfo(data = {}) {
  return axios.post(`?_m=ucenter&_a=update_driver_photo&token=${token}`, data);
}

// 获取广告列表
export function getBanner(params = {}) {
  return axios.get<IResponseData<any>>('?_m=register&_a=get_banner', {
    params,
  });
}

// 证件上传配置
export const getUploadConfig = (data: { driver_id: string }) => {
  return instanceDcs.post<IResponseData<IGetUploadConfigData>>('/', {
    name: 'register.cert.upload.config',
    encode_driver_id: data.driver_id,
    data,
  });
};

// 身份信息落库
export const identityInfoSave = (data: IIdentityInfoSaveParams) => {
  return instanceDic.post<IResponseData<{}>>('/', {
    name: 'save.tmp.identity.card',
    encode_driver_id: data.driver_id,
    data,
  },
  {
    timeout: 5000,
    showError: false,
  },
  );
};

// 提交司机身份信息
export const submitDriverInfo = (data: ISubmitDriverInfoParams) => {
  return instanceDic.post<
    IResponseData<{
      encodeDriverId: string;
    }>
  >('/', {
    name: 'driver.register.person.info',
    encode_driver_id: data.driver_id,
    city_id: data.city_id,
    data,
  });
};

// 车牌号支持的城市
export const getSupportCityListByVehiclePlate = (data: {
  vehiclePlate: string;
  driver_id: string;
  categoryList?: number[];
}) => {
  return instanceDcs.post<
    IResponseData<{
      cityList: ICityListItem[];
    }>
  >('/', {
    name: 'register.vehicle.support.city',
    encode_driver_id: data.driver_id,
    data,
  });
};

// 修改注册城市
export const changeRegisterCity = (data: {
  cityId: number;
  driver_id: string;
}) => {
  return instanceDic.post<IResponseData<{}>>('/', {
    name: 'driver.register.city.id',
    encode_driver_id: data.driver_id,
    data,
  });
};

// 获取后置上传的证件信息
export const getPostposeInfo = (data: { driver_id: string }) => {
  return instanceDic.post<
    IResponseData<{
      needSupplyIdCard: number;
    }>
  >('/', {
    name: 'driver.register.need.supply',
    encode_driver_id: data.driver_id,
    data,
  });
};

// 获取后置上传的证件信息
export const uploadIdCard = (data: IUploadIdCardParams) => {
  return instanceDic.post<IResponseData<{}>>('/', {
    name: 'driver.register.idcard.upload',
    encode_driver_id: data.driver_id,
    data,
  });
};

// 获取后置上传的证件信息
export const getEduTaskAndUrl = (data: { driver_id: string }) => {
  return instanceDic.post<IResponseData<IGetEduTaskAndUrlData>>('/', {
    name: 'get.edu.task.and.url',
    encode_driver_id: data.driver_id,
    data,
  });
};

/**
 * 准入人脸桩点接口
 */
export const faceAccess = (data: { driver_id: string }) => {
  return instanceDic.post<IResponseData<IFaceAccessCheckResponse>>('/', {
    version: '1.0',
    name: 'driver.access.face.check',
    encode_driver_id: data.driver_id,
    data,
  });
};

// 注册审核状态，所在城市是否开启了教育培训
export const getAuditStatusEduCityIsOpen = (data: { driver_id: string; city_id: number }) => {
  console.warn(data.driver_id, 'data.driver_id', data.city_id);
  return instanceDic.post<IResponseData<{ isOpen: boolean }>>('/', {
    name: 'edu.city.is.open.when.reg.audit',
    encode_driver_id: data.driver_id,
    cityId: data.city_id,
    data,
  });
};

/**
 * 准入人脸桩点接口
 */
export const faceCheck = (data: IFaceCheckParams & { driver_id: string }) => {
  return instanceDcs.post<IResponseData<IFaceCheckResponse>>('/', {
    version: '1.0',
    name: 'driver.module.judge.config',
    encode_driver_id: data.driver_id,
    device_id: data.device_id,
    device_type: data.device_type,
    data,
  });
};

/** 协议签署 */
export const signAgreement = (data: {
  driver_id: string;
  agreementList: { agreementType: AgreementEnum; agreementName: string }[];
}) => {
  return instanceDcs.post<IResponseData<IFaceCheckResponse>>('/', {
    version: '1.0',
    name: 'driver.agreement.sign',
    encode_driver_id: data.driver_id,
    data,
  });
};
// 获取是否是自动审核跟工单状态
export function fetchOrderStatus(data: { driver_id: string; workOrderType:number }) {
  return instanceDic.post<IResponseData<IDriverOrderStatus>>('/', {
    name: 'driver.work.order.status',
    encode_driver_id: data.driver_id,
    data,
  });
}

// 获取是否是自动审核跟工单状态
export function registerAccountVerifyStatus(data: { driver_id: string }) {
  return instanceDic.post<IResponseData<IRegisterAccountVerifyStatus>>('/', {
    name: 'register.account.verify.status',
    encode_driver_id: data.driver_id,
    // data,
  });
}

// 获取图片
export const getVideoUrl = (params: IGetImageParams) => {
  return axios.post<IGetImageData>(
    '/?_m=luna&_a=read_file&upload_type=xl_sticker',
    params,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );
};

export const getLunaUploadToken = (data?: { driver_id: string }) => {
  return instanceDic.post('/', {
    name: 'upload.token',
    encode_driver_id: data?.driver_id || '',
  });
};
export const getUploadId = (data: {fileName: string; driver_id?: string}) => {
  return instanceDic.post('/', {
    name: 'upload.id',
    data,
    encode_driver_id: data.driver_id || '',
  });
};
